/*
 * Copyright (c) 2017 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import can from 'can';
import Map from 'scripts/models/base/map';

export default Map.extend(
    {},
    {
        isPlayerDisqualified() {
            return (
                ['DQ', 'WD'].indexOf(this.attr('position.displayValue')) > -1
            );
        },

        isParUnderTotalPar() {
            let totalPar =
                (this.attr('roundScores.0.toPar.value') || 0) +
                (this.attr('roundScores.1.toPar.value') || 0);

            return totalPar < 0;
        },

        isTotalHidden() {
            return (
                ['DQ', 'WD'].indexOf(this.attr('position.displayValue')) > -1
            );
        },

        didPlayerStartFirstRound() {
            return this.attr('player.roundsInfo.0.started') === true;
        },

        define: {
            toParValue: {
                get: function() {
                    let isPlayerDisqualified = this.isPlayerDisqualified();
                    let toPar = this.attr('toPar');
                    let started = this.didPlayerStartFirstRound();

                    if (!started) {
                        return '-';
                    }

                    if (isPlayerDisqualified && toPar && toPar.value === 0) {
                        return '-';
                    } else if (isPlayerDisqualified) {
                        return '';
                    }

                    return toPar.displayValue;
                },
            },

            holesThroughValue: {
                get: function() {
                    let isPlayerDisqualified = this.isPlayerDisqualified();
                    let holesThrough = this.attr('holesThrough');
                    let started = this.didPlayerStartFirstRound();

                    if (isPlayerDisqualified) {
                        return '';
                    }

                    return holesThrough.displayValue;
                },
            },

            positionValue: {
                get: function() {
                    let position = this.attr('position');
                    let started = this.didPlayerStartFirstRound();
                    let displayValue = position && position.displayValue;

                    if (!started && ['WD', 'DQ'].indexOf(displayValue) === -1) {
                        return '-';
                    }

                    if (displayValue) {
                        return displayValue;
                    }

                    return '';
                },
            },

            toParTodayValue: {
                get: function() {
                    let isPlayerUnderCut = this.attr('isPlayerUnderCut');
                    let isPlayerDisqualified = this.isPlayerDisqualified();
                    let toParToday = this.attr('toParToday');
                    let started = this.didPlayerStartFirstRound();

                    if (!started) {
                        return '-';
                    }

                    if (isPlayerUnderCut && isPlayerDisqualified) {
                        return '';
                    }

                    if (
                        isPlayerUnderCut &&
                        !isPlayerDisqualified &&
                        ['to par', 'pos'].indexOf(this.attr('sortByKey')) === -1
                    ) {
                        return '';
                    }

                    if (
                        isPlayerDisqualified &&
                        toParToday &&
                        toParToday.value === 0
                    ) {
                        return '-';
                    }

                    return toParToday.displayValue;
                },
            },
        },
    },
);
